export enum Mode {
  Default = 'splash',
  UpdatePhone = 'updatePhone',
}

export enum Channel {
  Sms = 'sms',
  Email = 'email'
}
